import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { FilterClickedEvent } from '@atlassian/mpac-analytics';
import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../../../../../../common/constants/proptypes/CommonPropTypes";
import { ANALYTICS_SUBJECT_ID_TOPBAR_FACET_FILTER, EVENT_CHANNEL, EVENT_SOURCE } from "../../../../../../constants/analytics/events";
import AddonDiscoveryPropTypes from "../../../../../../constants/proptypes/AddonDiscoveryPropTypes";
import InternalFacetDropdown from "./InternalFacetDropdown";

var DisjunctiveFacetDropdown = /*#__PURE__*/function (_Component) {
  _inherits(DisjunctiveFacetDropdown, _Component);

  var _super = _createSuper(DisjunctiveFacetDropdown);

  function DisjunctiveFacetDropdown() {
    var _this;

    _classCallCheck(this, DisjunctiveFacetDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onDisjunctiveFacetRemoveClick", function (e) {
      _this.props.items.reduce(function (filters, i) {
        if (i.selected) {
          var newFilters = filters.update(i.facetKey, function (f) {
            return f.delete(i.facetValue);
          });

          _this.props.createAnalyticsEvent({
            eventType: FilterClickedEvent,
            actionSubjectId: ANALYTICS_SUBJECT_ID_TOPBAR_FACET_FILTER,
            source: EVENT_SOURCE,
            attributes: {
              currentPerspective: _this.props.perspective,
              filterKey: i.facetKey,
              filterValue: i.facetValue,
              selected: false
            }
          }).fire(EVENT_CHANNEL);

          _this.props.stateChangeRequested({
            filters: newFilters
          });

          return newFilters;
        }

        return filters;
      }, _this.props.filters);

      e.stopPropagation();
    });

    return _this;
  }

  _createClass(DisjunctiveFacetDropdown, [{
    key: "render",
    value: function render() {
      var numberSelectedItems = this.props.items.filter(function (i) {
        return i.selected;
      }).size;
      var someSelectedItemsExist = numberSelectedItems > 0;
      var label = someSelectedItemsExist ? "".concat(numberSelectedItems, " selected") : this.props.label;
      return /*#__PURE__*/React.createElement(InternalFacetDropdown, {
        closeOnItemSelected: false,
        facetBar: this.props.facetBar,
        facetValue: this.props.label,
        filters: this.props.filters,
        hasSelectedItem: someSelectedItemsExist,
        items: this.props.items,
        label: label,
        onItemActivated: this.props.onItemActivated,
        onRemoveClick: this.onDisjunctiveFacetRemoveClick,
        perspective: this.props.perspective
      });
    }
  }]);

  return DisjunctiveFacetDropdown;
}(Component);

_defineProperty(DisjunctiveFacetDropdown, "propTypes", {
  facetBar: PropTypes.oneOf(['top', 'side']),
  createAnalyticsEvent: PropTypes.func.isRequired,
  filters: CommonPropTypes.filters.isRequired,
  items: ImmutablePropTypes.list.isRequired,
  label: PropTypes.string.isRequired,
  onItemActivated: PropTypes.func.isRequired,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  stateChangeRequested: PropTypes.func.isRequired
});

export default withAnalyticsEvents()(DisjunctiveFacetDropdown);